import { lazy } from "react";

export { HH_INTEGRATION_PATH } from "./path";
export const HhIntegrationPage = lazy(() => import("./page"));
